import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Breakpoints } from '@bitcoin-portal/bitcoincom-pkg-theme';
// import { ShouganaiWidget, useWidget } from '@bitcoin-portal/mpc-widget';
import { GoArrowRight } from 'react-icons/go';
import Logo from './Logo';
import Hamburger from '../Hamburger';
import { handleRipple } from '../../../../helpers/ripple';
import { useBreakpoint } from '../Responsive/useBreakpoint';
import {
  Container,
  Content,
  NavbarContainer,
  NavbarWrapper,
  ItemsContainer,
  NavList,
  Item,
  BlankSpace,
  DesktopContainer,
  ResponsiveContainer,
  LoginButtonDesktop,
  StyledSearch,
} from './styled';

interface NavbarItem {
  key: string;
  text: string;
  link: string;
  openNewTab: boolean;
}

interface TopBarData {
  buttonText: string;
  buttonLink: string;
  loginButton: string;
  logoImage: {
    src: string;
    alt: string;
  };
  animatedLogo: {
    src: string;
  };
  navbarList: NavbarItem[];
}

interface TopBarProps {
  top: TopBarData;
  locale: string;
}

interface DropdownState {
  hamburger: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ top, locale }) => {
  const [isMounted, setIsMounted] = useState<boolean>(false);
  const realIsDesktop = useBreakpoint(Breakpoints.xl);
  const isDesktop = isMounted ? realIsDesktop : false;
  const navbarRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLAnchorElement>(null);
  const [dropdowns, setDropdowns] = useState<DropdownState>({
    hamburger: false,
  });
  // const { startLogin, hasAccount } = useWidget();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const closeDrodowns = (): void => {
    setDropdowns(prevState => ({
      ...prevState,
      hamburger: false,
    }));
  };

  const toggleDropdown = useCallback((name: keyof DropdownState): void => {
    setDropdowns(prevState =>
      Object.keys(prevState).reduce(
        (p, c) => ({
          ...p,
          [c]: c === name ? !prevState[c as keyof DropdownState] : false,
        }),
        {} as DropdownState,
      ),
    );
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target as Node)
      ) {
        closeDrodowns();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (buttonRef.current) {
        buttonRef.current.classList.add('bop');
        setTimeout(() => {
          if (buttonRef.current) {
            buttonRef.current.classList.remove('bop');
          }
        }, 1050);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container>
      <Content ref={navbarRef}>
        <NavbarContainer>
          <NavbarWrapper>
            <Logo
              logo={top.logoImage}
              animatedLogo={top.animatedLogo}
              locale={locale}
            />
            <ItemsContainer>
              <NavList>
                {top.navbarList.map((item: NavbarItem) => (
                  <Item
                    key={item.key}
                    href={item.link}
                    target={item.openNewTab ? '_blank' : undefined}
                  >
                    {item.text}
                  </Item>
                ))}
                <LoginButtonDesktop
                  ref={buttonRef}
                  href="https://accounts.bitcoin.com/dashboard"
                  target="_blank"
                  onMouseEnter={handleRipple}
                >
                  {top.loginButton}
                  <GoArrowRight size={20} color="#1c1c1c" />
                </LoginButtonDesktop>
              </NavList>
            </ItemsContainer>
            {!isDesktop && <BlankSpace />}
            <StyledSearch locale="en" visible rebrand />
            <DesktopContainer>
              {/* {hasAccount ? (
                <ShouganaiWidget />
              ) : (
                <LoginButton
                  ref={buttonRef}
                  onClick={startLogin}
                  onMouseEnter={handleRipple}
                >
                  {top.loginButton}
                </LoginButton>
              )} */}
            </DesktopContainer>
            <ResponsiveContainer>
              <Hamburger
                isOpen={dropdowns.hamburger}
                onClick={() => toggleDropdown('hamburger')}
                navbarList={top.navbarList}
                buttonData={{
                  buttonText: top.buttonText,
                  buttonLink: top.buttonLink,
                }}
              />
            </ResponsiveContainer>
          </NavbarWrapper>
        </NavbarContainer>
      </Content>
    </Container>
  );
};

export default TopBar;
